const Logo = ({ dark = false }) => (
  <span
    className={`inline-flex items-center ${dark ? "rounded-xl bg-white px-3.5 py-2.5" : ""}`}
    data-testid="kryvo-logo"
  >
    <img
      src="/kryvo-logo.png"
      alt="Kryvo Technologies"
      width="560"
      height="148"
      className="h-8 w-auto sm:h-9"
      data-testid="kryvo-logo-image"
    />
  </span>
);

export default Logo;
